/**
 * 菜单匹配手册
 */
const state = {
  isMenuItems: [],
  getMenuItemData: [],
  //菜单对照字段表
  menuItems: [
    { index: "101", menuName: "首页", path: "/", name: "" },
    {
      index: "201",
      menuName: "走进湿地",
      path: "/stepInWetland/index/0",
      name: ""
    },
    {
      index: "211",
      menuName: "总体规划",
      path: "/stepInWetland/index/StepInWetland",
      name: "StepInWetland"
    },
    {
      index: "212",
      menuName: "湿地简介",
      path: "/stepInWetland/index/WetlandDescription",
      name: "WetlandDescription"
    },

    {
      index: "213",
      menuName: "动物资源",
      path: "/stepInWetland/index/AnimalResource",
      name: "AnimalResource"
    },
    {
      index: "214",
      menuName: "植物资源",
      path: "/stepInWetland/index/PlantResource",
      name: "PlantResource"
    },
    {
      index: "215",
      menuName: "旅游资源",
      path: "/stepInWetland/index/TourismResource",
      name: "TourismResource"
    },
    {
      index: "216",
      menuName: "重大事迹",
      path: "/stepInWetland/index/MajorEvents",
      name: "MajorEvents"
    },
    {
      index: "217",
      menuName: "游客留言",
      path: "/stepInWetland/index/TouristMessage",
      name: "TouristMessage"
    },
    {
      index: "301",
      menuName: "湿地管控",
      path: "/wetlandOneMap/index/0",
      name: ""
    },
    {
      index: "311",
      menuName: "湿地一张图",
      path: "/wetlandOneMap/index/WetlandOneMap",
      name: "WetlandOneMap"
    },
    {
      index: "312",
      menuName: "环境监测",
      path: "/wetlandOneMap/index/EnvironmentMonitor",
      name: "EnvironmentMonitor"
    },
    {
      index: "313",
      menuName: "预警发布",
      path: "/wetlandOneMap/index/WarningIssued",
      name: "WarningIssued"
    },
    {
      index: "314",
      menuName: "视频监控",
      path: "/wetlandOneMap/index/VideoSurveillance",
      name: "VideoSurveillance"
    },
    {
      index: "315",
      menuName: "巡护展示",
      path: "/wetlandOneMap/index/PatrolDisplay",
      name: "PatrolDisplay"
    },
    {
      index: "401",
      menuName: "科普宣教",
      path: "/popularScience/index/0",
      name: ""
    },
    {
      index: "411",
      menuName: "湿地课堂",
      path: "/popularScience/index/PopularScience4",
      name: "PopularScience4"
    },
    {
      index: "412",
      menuName: "湿地宣教",
      path: "/popularScience/index/PopularScience5",
      name: "PopularScience5"
    },
    {
      index: "413",
      menuName: "政策法规",
      path: "/popularScience/journalismIndex/PopularScience6",
      name: "PopularScience6"
    },
    {
      index: "414",
      menuName: "通知通告",
      path: "/popularScience/journalismIndex/PopularScience7",
      name: "PopularScience7"
    },
    {
      index: "501",
      menuName: "关于我们",
      path: "/about/index/0",
      name: ""
    },
    {
      index: "511",
      menuName: "关于我们",
      path: "/about/index/about",
      name: "About"
    },
    {
      index: "512",
      menuName: "重大事迹",
      path: "/about/index/MajorEvents",
      name: "MajorEvents"
    },
    {
      index: "513",
      menuName: "游客留言",
      path: "/about/index/TouristMessage",
      name: "TouristMessage"
    },
    {
      index: "601",
      menuName: "虚拟体验",
      path: "/virtualExperience/virtualExperience",
      name: "VirtualExperience"
    },
    {
      index: "701",
      menuName: "新闻动态",
      path: "/popularScience/journalismIndex/0",
      name: ""
    },
    // {
    //   index: "711",
    //   menuName: "政策法规",
    //   path: "/popularScience/journalismIndex/PopularScience6",
    //   name: "PopularScience6"
    // },
    // {
    //   index: "712",
    //   menuName: "通知通告",
    //   path: "/popularScience/journalismIndex/PopularScience7",
    //   name: "PopularScience7"
    // }
  ],
  //默认需要显示的菜单
  menuItemData: []
};

export default {
  state
};



// WEBPACK FOOTER //
// ./src/store/modules/menu.js